import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'cargoes-generic-table-view',
  templateUrl: './generic-table-view.component.html',
  styleUrls: ['./generic-table-view.component.less']
})
export class GenericTableViewComponent implements OnInit {

  constructor() { }

  @Input() dummyArray: any

  ngOnInit() {
  }

}
